/* eslint-disable no-param-reassign */
import { createEntityReducer } from 'util/reducers'

export default createEntityReducer('contacts', {
  transformEntity: contact => {
    if (contact.customFieldValues && contact.customFieldValues.nodes) {
      contact.customFieldValues = contact.customFieldValues.nodes.reduce(
        (result, field) => {
          result[field.key] = field
          return result
        },
        {}
      )
    }
    if (contact.companies) {
      contact.companies = contact.companies.nodes
    }
    return contact
  },
})
